module.exports = __webpack_public_path__ + "static/img/yuliBg_Staking.79b0763a.png";